import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import * as actions from '../store/modules/cerc/actions'
import { StoreState } from '../store'

export const useOptIn = () => {
    const { cnpj_cpf } = useSelector((state: StoreState) => state.auth.user)
    const dispatch = useDispatch()
    const handleAcceptOptIn = (e: React.FormEvent) => {
        e.preventDefault()
        dispatch(actions.cerqRequestOptIn({ cnpj_cpf }))
    }
    return {
        handleAcceptOptIn,
    }
}
